<template>
  <v-row no-gutters class="fill-height">
    <crud-factory :serviceName="serviceName" :crudDialog="crudDialog" />
  </v-row>
</template>

<script>
export default {
  components: {
    crudFactory: () => import("./CrudFactory"),
  },
  data() {
    return {
      serviceName: "users",
      crudDialog: {
        large: false,
        createTitle: "Nou usuari",
        modelKeyTitle: "email",
      },
    }
  },
}
</script>

<style lang="scss" scoped />
